import React from "react";
import Carousel from "react-multi-carousel";
import { Image, Container } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";

import navarrow from "../assets/navarrow.svg";
import { Link } from "react-router-dom";

import "./projects.css";

import projects from "./projectsData";

function ProjectList2({ responsive }) {
  return (
    <Carousel
      additionalTransfrom={0}
      arrows
      autoPlaySpeed={3000}
      centerMode={false}
      className=""
      containerClass="container-with-dots"
      draggable
      infinite
      keyBoardControl
      minimumTouchDrag={80}
      pauseOnHover
      responsive={responsive}
      showDots={false}
      slidesToSlide={1}
      swipeable
    >
      {projects.map((item) => (
        <Container fluid key={item.id}>
          <Link to={`/project/${item.slug}`}>
            <figure className="figure-container">
              <Image width="100%" src={item.imageUrl || "/placeholder.jpg"} alt={item.title} />

              <figcaption style={{ padding: "0.7rem" }} className="caption">
                <div style={{ display: "flex", gap: 5 }}>
                  <div>
                    <h6 style={{ fontFamily: "Clash Display" }}>
                      <strong>{item.title}</strong>
                    </h6>
                    <p
                      style={{
                        fontSize: "0.67rem",
                        fontFamily: "Jost, sans-serif",
                        lineHeight: "199%",
                      }}
                    >
                      {item.description && item.description[0]}
                    </p>
                  </div>
                  <div>
                    <Image style={{ marginTop: "50%" }} src={navarrow} />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    marginBottom: "0.5rem",
                  }}
                >
                  {item.languages &&
                    item.languages.map((subItem) => (
                      <div
                        key={subItem.name}
                        style={{
                          fontSize: "0.6rem",
                          backgroundColor: "grey",
                          borderRadius: "5rem",
                          padding: "0.3rem 1rem",
                        }}
                      >
                        {subItem.name}
                      </div>
                    ))}
                </div>
              </figcaption>
            </figure>
          </Link>
        </Container>
      ))}
    </Carousel>
  );
}

export default ProjectList2;
